<template>
  <div>
    <v-container fluid grid-list-md>
      <v-dialog v-model="details.visible"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar>
            <v-btn icon @click="closeDetails()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{details.transactionnum}}</v-toolbar-title>
            
            <!-- <template v-if="details.actions">
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn 
                  v-for="action in details.actions"
                  :key="action.id"
                  flat
                  :color="action.color || 'info'" 
                  @click.stop="handleSimpleAction(details.ID, action.id)"
                >
                  <v-icon left>{{action.icon}}</v-icon>
                  {{$t(action.label)}}
                </v-btn>
              </v-toolbar-items>

            </template> -->

          </v-toolbar>
          <v-list three-line subheader>
            <v-subheader class="transaction-details" style="flex-direction: row; align-items: flex-start; flex-wrap: wrap">
              <div style="flex: 1; min-width: 320px">
                <div class="transaction-details-field" v-for="(data, index) in details.details" :key="index">
                  <label>{{ $t(data.label) }}:</label>
                  <span>{{getTransactionValue(data.value == null ? '-' : data.value, data, $i18n.locale)}}</span>
                </div>
              </div>
              <div style="flex: 1; min-width: 480px" v-html="details.description">
              </div>
            </v-subheader>

            <v-subheader :class="`transaction-dialog`" v-if="details.actions && details.actions.length">
              <template>
                <!-- <div v-html="$t(details.dialog.text)"></div> -->
                <div>
                  <v-btn 
                    v-for="action in details.actions"
                    :key="action.id"
                    flat
                    :color="action.color || 'info'" 
                    @click.stop="handleSimpleAction(details.ID, action.id)"
                  >
                    <v-icon left>{{action.icon}}</v-icon>
                    {{$t(action.label)}}
                  </v-btn>
                </div>
              </template>
            </v-subheader>

            <v-content fluid style="padding-top: 0 !important;" v-if="details.cart && details.cart.items.length">
              <!-- <h3 class="ma-3">{{$t('Transactions.Cart')}}</h3> -->
              <v-layout class="mb-2">
                <v-flex>
                  <v-data-table
                    :headers="cartHeaders"
                    :items="details.cart ? details.cart.items : []"
                    :rows-per-page-items="rowsPerPageItems"
                    must-sort
                    disable-initial-sort
                    hide-actions
                    class="elevation-1 mt-3"
                    @update:pagination="onUpdatePagination"
                  >

                    <template slot="headerCell" slot-scope="props">
                      <span>{{ $t(props.header.text) }}</span>
                    </template>

                    <!-- <template slot="items" slot-scope="props">
                      <td>{{ props.item.itemnum }}</td>
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-right">
                        {{ props.item.amount}}
                      </td>
                      <td class="text-xs-right">{{ props.item.taxrate.toLocaleString($i18n.locale) }}</td>
                      <td class="text-xs-right">{{ props.item.sellingprice.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
                      <td class="text-xs-right">{{ props.item.nettotal.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
                    </template> -->

                    <template slot="items" slot-scope="props">
                      <tr>
                      <td
                        v-for="header in cartHeaders.filter(x=>!x.default)"
                        :key="header.value"
                        :class="header.align ? 'text-xs-' + header.align : undefined"
                      >
                        {{getTransactionValue(props.item[header.value], header, $i18n.locale)}}
                      </td>
                      </tr>
                    </template>

                    <template slot="footer" v-if="details.cart && !details.cart.hideTotal && details.cart.items.length > 0">
                      <td class="grey subheading"><strong>{{ $t('Common.total') }}</strong></td>
                      <td class="grey"></td>
                      <td class="grey"></td>
                      <td colspan="2" class="grey text-xs-right caption">
                        <div>{{ $t('Common.netAmount')}} :</div>
                        <div>{{ $t('Common.taxAmount')}} :</div>
                        <div>{{ $t('Common.grossAmount')}} :</div></td>
                      <td class="grey text-xs-right">
                        <div>{{ details.cart.netamount.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                        <div>{{ details.cart.tax.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                        <div>{{ details.cart.total.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                      </td>
                    </template>

                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-content>

            <!-- <v-data-table
              :headers="cartHeaders"
              :items="details.cart ? details.cart.items : []"
              :rows-per-page-items="rowsPerPageItems"
              must-sort
              disable-initial-sort
              hide-actions
              class="elevation-1 mt-3"
              @update:pagination="onUpdatePagination"
            >

              <template slot="headerCell" slot-scope="props">
                <span>{{ $t(props.header.text) }}</span>
              </template>

              <template slot="items" slot-scope="props">
                <td>{{ props.item.itemnum }}</td>
                <td>{{ props.item.name }}</td>
                <td class="text-xs-right">
                  {{ props.item.amount}}
                </td>
                <td class="text-xs-right">{{ props.item.taxrate.toLocaleString($i18n.locale) }}</td>
                <td class="text-xs-right">{{ props.item.sellingprice.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
                <td class="text-xs-right">{{ props.item.nettotal.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              </template>

              <template slot="footer" v-if="details.cart && details.cart.items.length > 0">
                <td class="grey subheading"><strong>{{ $t('Common.total') }}</strong></td>
                <td class="grey"></td>
                <td class="grey"></td>
                <td colspan="2" class="grey text-xs-right caption">
                  <div>{{ $t('Common.netAmount')}} :</div>
                  <div>{{ $t('Common.taxAmount')}} :</div>
                  <div>{{ $t('Common.grossAmount')}} :</div></td>
                <td class="grey text-xs-right">
                  <div>{{ details.cart.netamount.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                  <div>{{ details.cart.tax.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                  <div>{{ details.cart.total.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                </td>
              </template>

            </v-data-table> -->

          </v-list>
        </v-card>
      </v-dialog>

      <h1>{{ config.title ? config.title : $t(`Application.${config.type}`) }}</h1>
      <v-data-table
        :headers="headers"
        :items="transactions"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="state.pagination"
        :total-items = "state.pagination.totalItems"
        must-sort
        disable-initial-sort
        @update:pagination="onUpdatePagination"
        class="elevation-1 mt-3 no-row-highlight"
      >

        <template slot="headerCell" slot-scope="props">
          <template v-if="props.header.value === 'transactionnum'" class="qwerty">
            <span class="filter-column-text">{{ $t(props.header.text) }}</span>
            <v-edit-dialog
              ref="filter-transactionnum"
              lazy
              :class="'filter-column-editor' + (state.filter ? ' active' : '')"
            >
              <v-icon class="ml-1 mr-1" @click.stop="onSearchClick">search</v-icon>
              <v-text-field
                slot="input"
                v-model="state.filter"
                :label="$t('Common.filterText')"
                clearable
                single-line
                @change="onFilterChanged"
              ></v-text-field>
            </v-edit-dialog>
          </template>

          <span v-else>{{ $t(props.header.text) }}</span>
        </template>

        <template slot="items" slot-scope="props">
          <tr @click="openDetails(props.item)">
          <td
            v-for="header in headers.filter(x=>!x.default)"
           :key="header.value"
           :class="header.align ? 'text-xs-' + header.align : undefined"
          >
            {{getTransactionValue(props.item[header.value], header, $i18n.locale)}}
          </td>

          <td
            v-for="header in headers.filter(x=>x.simpleAction)"
           :key="header.value"
           :class="header.align ? 'text-xs-' + header.align : undefined"
          >
            <v-btn :flat="true" :color="header.color || 'info'" @click.stop="handleSimpleAction(props.item.ID, header.value)" small style="min-width: 40px">
              <v-icon>{{header.icon}}</v-icon>
            </v-btn>
          </td>

          <td class="text-xs-center" v-if="!hidePrint">
            <v-btn :flat="true" color="info" @click.stop="printTransaction(props.item)" small style="min-width: 40px">
              <v-icon>{{ props.item.printing ? 'fas fa-circle-notch fa-spin' : 'print'}}</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-center" v-if="showAddToCart">
            <v-btn :flat="true" color="info" @click.stop="duplicate(props.item)" small style="min-width: 40px">
              <v-icon>{{ props.item.cloning ? 'fas fa-circle-notch fa-spin' : 'fas fa-cart-plus'}}</v-icon>
            </v-btn>
          </td>
          </tr>
        </template>

      </v-data-table>
    </v-container>
  </div>
</template>

<script>
  import store from '../store'
  import { saveAs } from 'file-saver'

  const TYPE_ORDERS = 'orders'
  const TYPE_BILLING = 'billing'
  const TYPE_QUOTES = 'quotes'
  const TYPE_DELIVERIES = 'deliveries'

  function createHeaders(columnsConfig, actionsConfig, sourceMapper) {
    let headers = [];
    if (columnsConfig) {
      columnsConfig.forEach(col => {
        let value = col.field;
        value = Array.isArray(value) ? value.join('__') : value;
        value = value.replace('.', '');
        headers.push({
          text: col.label,
          value,
          sortable: col.sortable,
          align: col.align,
          width: col.width,
          type: col.type,
        });
        const key = JSON.stringify(Array.isArray(col.field) ? col.field: [col.field]);
        if (sourceMapper) {
          sourceMapper[key] = value;
        }
      });

      (actionsConfig || []).forEach(action => {
        headers.push({
          text: action.label,
          value: action.id,
          sortable: false,
          align: 'center',
          width: '40px',
          default: true,
          simpleAction: true,
          icon: action.icon,
          color: action.color,
        });
      })
    }
    return headers;
  }

  function mapItems(items, sourceMapper) {
    const resItems = (items || []).map(t => {
      let res = Object
        .keys(sourceMapper)
        .reduce((p, map) => {
          const field = sourceMapper[map];
          JSON.parse(map).reverse().forEach(c => {
            let currentVal = t;
            c.split('.').forEach((prop)=> {
              if (currentVal !== null && currentVal !== undefined) {
                currentVal = currentVal[prop];
              }
            });
            if (currentVal) {
              p[field] = currentVal;
            }
          });
          return p;
        }, {});
      return { ...t, ...res, };
    });

    return resItems;
  }

  export default {
    name: 'Transactions',
    props: {
      config: Object,
    },
    mounted() {
      this.closeDetails = this.closeDetails.bind(this);
    },
    computed: {
      type() {
        switch(this.config.type) {
          case TYPE_QUOTES: return 0;
          case TYPE_ORDERS: return 1;
          case TYPE_DELIVERIES: return 2;
          case TYPE_BILLING: return 3;
          default:
            throw new Error(`Transaction.vue ERROR! ${this.config.type} is invalid transaction type`)
        }
      },
      state() {
        if (!store[this.config.type]) {
          store[this.config.type] = {
            pagination: {},
            filter: ''
          };
        }
        return store[this.config.type];
      },
    },
    data() {
      let headers = [];
      const sourceMapper = {};
      const hidePrint = this.config.hidePrint;
      const showAddToCart = this.config.type === TYPE_ORDERS && !this.config.hideAddToCart;

      headers = createHeaders(this.config.columns, this.config.actions, sourceMapper);
      
      console.log('sourceMapper', sourceMapper)

      if (this.config.columns) {
        !this.config.hidePrint && headers.push({
          text: 'Action.print',
          value: 'print',
          sortable: false,
          align: 'center',
          width: '40px',
          default: true,
        });

        showAddToCart && headers.push({
          text: 'Action.addToCart',
          value: 'fas fa-cart-plus',
          sortable: false,
          align: 'center',
          width: '40px',
          default: true,
        });
      }

      let cartHeaders = [
        {text: 'Common.itemNum', value: 'itemnum', align: 'left'},
        {text: 'Common.itemName', value: 'name', align: 'left'},
        {text: 'Common.quantity', value: 'amount', align: 'center', width: '100px'},
        {text: 'Common.taxPercent', value: 'taxrate', align: 'right'},
        {text: 'Common.itemPrice', value: 'sellingprice', align: 'right', type: 'num'},
        {text: 'Common.total', value: 'nettotal', align: 'right', type: 'num'},
      ];

      const cartItemsConfig = this.config.cart && this.config.cart.columns;
      console.log('cart config', this.config.cart)
      let cartSourceMapper = {
        '["amount"]': "amount",
        '["itemnum"]': "itemnum",
        '["name"]': "name",
        '["taxrate"]': "taxrate",
        '["sellingprice"]': "sellingprice",
        '["nettotal"]': "nettotal",
      };
      if (cartItemsConfig) {
        cartSourceMapper = {}
        cartHeaders = createHeaders(cartItemsConfig, undefined, cartSourceMapper)
      }

      console.log('Cart headers', cartHeaders);
      console.log('Cart cartSourceMapper', cartSourceMapper);

      return {
        headers,
        cartHeaders,
        sourceMapper,
        cartSourceMapper,
        hidePrint,
        showAddToCart,
        rowsPerPageItems: [12, 24, 48, 96, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }],
        transactions: [],
        details: {visible: false, cart: null},
      };
    },
    methods: {
      refresh() {
        const params = {
          type: this.type,
          offset: (this.state.pagination.page || 1) - 1,
          limit: this.state.pagination.rowsPerPage,
          ...(this.config.filters || {})
        };
        if (this.state.pagination.sortBy) {
          params['orderby'] = (this.state.pagination.descending ? '-' : '') + this.state.pagination.sortBy;
        }
        if (this.state.filter) {
          params['search'] = this.state.filter;
        }

        this.$http.get(this.$root.route('transactions'), {params}).then(
          response => {

            this.transactions = mapItems(response.body.result.data, this.sourceMapper);

            console.log('transactions', this.transactions);
            this.transactions.forEach(o => {
              o.total = Math.round((o.netamount + o.tax) * 1000000) / 1000000
            });
            this.state.pagination.totalItems = response.body.result.count;
          },
          response => {
            console.error('Fail', response);
          });
      },
      printTransaction(transaction) {
        transaction.printing = true;
        this.transactions = [...this.transactions];
        const params = { responseType: 'arraybuffer' }; // or { responseType: 'blob' }
        this.$http.get(this.$root.route('transaction/' + transaction.ID + '/print'), params).then(
          response => {
            const blob = new Blob([response.body], {type: "text/pdf;charset=utf-8"}); // or {type: 'application/pdf'}
            saveAs(blob, `${transaction.transactionnum}.pdf`);
            delete transaction.printing;
            this.transactions = [...this.transactions];
          },
          response => {
            console.error('Fail', response);
          });
      },

      async handleSimpleAction(transactionId, actionId) {
        this.loading = true
        try {
          // /transaction/:ID/action/:action
          await this.$http.post(this.$root.route(`transaction/${transactionId}/action/${actionId}`), null);
          await this.refresh();
        }
        catch (err) {
          console.error(err)
        }
        finally {
          this.loading = false
        }
        this.$forceUpdate()
      },

      onUpdatePagination(paginationObject) {
        Object.keys(paginationObject).forEach(key => this.state.pagination[key] = paginationObject[key]);
        this.refresh()
      },
      onFilterChanged() {
        this.$refs['filter-transactionnum'].isActive = false;
        this.refresh();
      },
      onSearchClick() {
        this.$refs['filter-transactionnum'].isActive = true;
      },
      getTransactionValue(res, header, i18Locale) {
        // const res = transaction[header.value];

        if (header.options) {
          return this.$t(header.options[res] || res);
        }
        if (header.type === 'num') {
          return res.toLocaleString(i18Locale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (header.type === 'date') {
          return !res ? '-' : new Date(res * 1000).toLocaleDateString(
            i18Locale, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          });
        }
        return res;
      },
      duplicate(transaction) {
        transaction.cloning = true;
        this.transactions = [
          ...this.transactions,
        ]

        this.$http.get(this.$root.route('transaction/' + transaction.ID + ''))
          .then(({body}) => {
            delete transaction.cloning;
            this.transactions = [
              ...this.transactions,
            ]
            const items = {};
            body.result.cart.items.forEach(({itemnum, amount}) => {
              items[itemnum] = amount;
            });

            this.$root.globalComponent.addToCart(items);
          });
      },
      openDetails(transaction) {
        const cartConfig = this.config.cart;
        this.$http.get(this.$root.route('transaction/' + transaction.ID + ''))
          .then(({body}) => {
            console.log('body', body);
            this.details = {
              items: {},
              ...body.result,
              visible: true,
              actions: this.config.actions,
              details: (this.config.detailFields || []).map(({field, ...rest}) => ({
                ...rest,
                value: field
                  .split('.')
                  .reduce((currentVal, prop) => currentVal !== null && currentVal !== undefined ? currentVal[prop] : null, body.result)
              })),
            };

            if (cartConfig && this.details.cart) {
              console.log('cartConfig.columns', cartConfig.columns)
              this.details.cart.hideTotal = cartConfig.total === false;
            }

            this.details.cart.items = mapItems(this.details.cart.items, this.cartSourceMapper);

            console.log('details.cart', this.details.cart);
            // console.log('details', this.details.details);

            history.pushState(null, document.title, location.href);
            window.addEventListener('popstate', this.closeDetails);
          });

        return false;
      },
      closeDetails() {
        this.details = {
          ...this.details,
          visible: false,
        };

        window.removeEventListener('popstate', this.closeDetails);
      }
    }
  }
</script>

<style lang="scss">
  .no-row-highlight tbody {
    tr:hover {
      background-color: transparent !important;
      cursor: default;
    }
  }
  .filter-column-editor + i {
    float: left;
    margin-left: 6px;
  }
</style>

<style lang="scss" scoped>

  .transaction-dialog {
    flex-direction: column;
    height: initial;
    padding: 16px;
    background: #e8f4fe;
    border: thick solid var(--color, #0072B5);
    border-width: 4px;
  }

  .transaction-details {
    flex-direction: column;
    height: initial;
    margin-top: 16px;
  }
  .transaction-details-field {
    flex: 0;
    min-width: 100%;
  }
  .transaction-details-field label {
    min-width: 125px;
    display: inline-block;
    margin-right: 16px;
  }
  .action-color {
    color: rgb(246, 127, 0) !important;
  }

  .filter-column-editor {
    display: inline-block !important;
    width: 20px !important;
  }
  .filter-column-editor.active i {
    opacity: 1 !important;
  }
  .filter-column-editor i {
    transform: none !important;
    color: white !important;
    opacity: 0.5 !important;
  }
  span.filter-column-text {
    float: left;
  }
</style>
